module.exports = __webpack_public_path__ + "img/evoucher_img_default.fd479eaa.svg";